import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useConfig from "../../hooks/useConfig";
import { InfoRounded } from "@mui/icons-material";

// https://locusrobotics.atlassian.net/browse/HUB-2477
export const AnalyticsDisruptionBanner = () => {
  const theme = useTheme();
  const { navType } = useConfig();

  const bannerMessage = "We will be performing scheduled maintenance in the EMEA region at 20:00 UTC / 22:00 CEST / 16:00 EDT. During this time, dashboard loading may be intermittently affected for EMEA users for approximately 15 minutes.";

  return (
    <Box
      id="globalAnalyticsDisruptionBanner"
      sx={{
        py: 1,
        pr: 1,
        mb: 1,
        backgroundColor: theme.palette.background.paper,
        display: "flex",

        color:
          navType === "dark"
            ? theme.palette.text.primary
            : theme.palette.text.primary
      }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginRight: "10px",
          marginLeft: "10px",
        }}
      >
        <InfoRounded stroke={1.5} size="20px" />
      </div>
      <Typography variant="subtitle1" color="inherit">
        {bannerMessage}
      </Typography>
    </Box>
  );
};
